// 2-qadam matnlari bilan ishlash (sof funksiyalar).
// texts: [{ slide_number, speech_text }] — slide_number 1 dan boshlanadi.

const slideOf = (item, index) => (item && item.slide_number != null ? Number(item.slide_number) : index + 1);

// Server javobidan boshlang'ich matnlar — AddLesson'dagi mavjud qoida bilan aynan bir xil
export function baseTextsFromResponse(response) {
    if (response?.speech_text?.length > 0) return response.speech_text;
    return Array.from({ length: response?.num_pages || 0 }, (_, index) => ({
        slide_number: index + 1,
        speech_text: '',
    }));
}

// TXT sahifalarini mos slaydlarga qo'yadi. Faylda yo'q sahifalarga tegilmaydi, massiv tuzilishi o'zgarmaydi.
// Natija: { texts, applied: [slide], missing: [faylda bor, lekin texts'da yo'q sahifalar] }
export function applySpeakerNotes(texts, pages) {
    const list = Array.isArray(texts) ? texts : [];
    if (!pages) return { texts: list, applied: [], missing: [] };

    const applied = [];
    const next = list.map((item, index) => {
        const slide = slideOf(item, index);
        if (!Object.prototype.hasOwnProperty.call(pages, slide)) return item;
        applied.push(slide);
        return { ...item, speech_text: pages[slide] };
    });
    const present = new Set(list.map(slideOf));
    const missing = Object.keys(pages).map(Number).filter((page) => !present.has(page)).sort((a, b) => a - b);
    return { texts: next, applied, missing };
}

// Har slayd uchun matn manbai: { [slide]: { source: 'txt' | 'ai' | null, text } }
// text — manba bergan matn; joriy matn undan farq qilsa, sahifa "tahrirlangan" hisoblanadi.
export function buildSources(texts, appliedSlides = []) {
    const fromTxt = new Set(appliedSlides);
    const sources = {};
    (texts || []).forEach((item, index) => {
        const slide = slideOf(item, index);
        const text = item?.speech_text || '';
        let source = null;
        if (fromTxt.has(slide)) source = 'txt';
        else if (text.trim()) source = 'ai';
        sources[slide] = { source, text };
    });
    return sources;
}

// Faqat berilgan slaydlarni "txt" deb belgilash (2-qadamda qayta to'ldirishdan keyin)
export function markFromTxt(sources, texts, appliedSlides) {
    const next = { ...sources };
    const applied = new Set(appliedSlides);
    (texts || []).forEach((item, index) => {
        const slide = slideOf(item, index);
        if (applied.has(slide)) next[slide] = { source: 'txt', text: item.speech_text || '' };
    });
    return next;
}

// Badge holati: 'txt' | 'ai' | 'edited' | null (manbalar hali hisoblanmagan bo'lsa — null)
export function sourceState(item, entry) {
    const text = item?.speech_text || '';
    if (!entry) return null;
    if (text !== entry.text) return 'edited';
    return entry.source;
}

export function slidesByState(texts, sources, state) {
    return (texts || [])
        .map((item, index) => ({ slide: slideOf(item, index), item }))
        .filter(({ slide, item }) => sourceState(item, sources?.[slide]) === state)
        .map(({ slide }) => slide);
}

export function emptySlides(texts) {
    return (texts || [])
        .map((item, index) => ({ slide: slideOf(item, index), item }))
        .filter(({ item }) => !(item?.speech_text || '').trim())
        .map(({ slide }) => slide);
}

// 2-qadamda almashtirishdan oldingi hisob: nechta sahifa almashadi, shulardan nechtasi qo'lda tahrirlangan
export function replacementSummary(texts, sources, pages) {
    const { applied } = applySpeakerNotes(texts, pages);
    const edited = new Set(slidesByState(texts, sources, 'edited'));
    return { total: applied.length, edited: applied.filter((slide) => edited.has(slide)).length, applied };
}

export { slideOf };
